import { html, LitElement, css, unsafeCSS } from 'lit';
import { TooltipComponent } from '../components/tooltip';
import { friendlyURL, isTouchDevice } from '../shared/utils';

import style from './card.scss';

export class CardPart extends LitElement {

    static get properties() {
        return {
            data: Object,
            id: Number,
            inline: Boolean,
            imageonly: Boolean,
            header: Boolean,
            talent: String,
            ver: String
        }
    }

    constructor() {
        super();
        this.data = null;
        this.id = null;
        this.inline = false;
        this.imageonly = false;
        this.header = false;
        this.tooltip = new TooltipComponent();
        this.talent = '';
        this.ver = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
    }

    attributeChangedCallback(name, old, value) {
        super.attributeChangedCallback(name, old, value)
        if (name === 'id' && old !== value)
            this.fetchData();
    }

    async fetchData() {
        if (!this.id) {
            return;
        }
        let cardjson = await fetch(`./api/card/${this.id}?part=true&talent=${this.talent}&ver=${this.ver}`);
        let card = await cardjson.json();
        this.data = card;
    }

    render() {
        let card = this.data;
        if (!this.data || !this.id)
            return html``;
        return html`
            ${this.tooltip}
            ${!this.inline ? html`
                <div 
                    @click=${() => { if (!isTouchDevice() && !this.imageonly) window.location = `./${this.talent === 'true' ? 'talent' : 'card'}/${friendlyURL(card.name)}` }} 
                    @mouseleave=${this.tooltip.debouncer((ev) => { if (!this.imageonly) this.tooltip.mouseOut(ev) })} 
                    @mouseenter=${this.tooltip.debouncer((ev) => { if (!this.imageonly) this.tooltip.mouseOver(ev, card.id) })} 
                    class="artwork${this.header ? ' header-image' : ''}"
                    style="background-image:url(./images/icons/${(card.artwork || 'dt_portrait_bolgar').replace(/ /g, '%20')}.webp);${this.imageonly ? 'cursor:default;' : ''}">
                </div>  
            `: ''}        
            ${!this.imageonly ? html`
                <div
                    @mouseleave=${this.tooltip.debouncer((ev) => this.tooltip.mouseOut(ev))} 
                    @mouseenter=${this.tooltip.debouncer((ev) => this.tooltip.mouseOver(ev, card.id))}
                    class="name ${card.category === 10 ? 'talent' : 'card'}-rarity-${card.rarity} ${!this.inline ? 'img-name' : 'inline-name'}">
                        ${!isTouchDevice() ? html`<a href="./${this.talent === 'true' ? 'talent' : 'card'}/${friendlyURL(card.name)}">${card.nameLocalized||card.name}</a>` : card.nameLocalized||card.name}                    
                    </div>                                
                </div>  
            `: ''}                                          
        `;
    }
}

customElements.define('card-part', CardPart);